import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import LoginIcon from "@mui/icons-material/Login";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { auth } from "../firebase/config";

import {
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBDropdownItem,
  MDBBtn,
} from "mdb-react-ui-kit";
import { Link, useNavigate } from "react-router-dom";
import { Add, Logout } from "@mui/icons-material";
import Auth from "../firebase/Authentication";

function NavigationBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [open, setOpen] = React.useState(true);

  const navigate = useNavigate();

  const handleClick = () => {
    setOpen(!open);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar sx={{ backgroundColor: "#046307" }} position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "Lucida Handwriting, cursive",
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {/* <img src="Images/nav.png" style={{ width: "300px" }} alt="logo" /> */}
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton onClick={handleClick}>
                  <ListItemText primary="Products" />
                  {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link to="/category/hand_bags">
                      <ListItemText primary="Hand Bags" />
                    </Link>

                    <Link to="/category/purses">
                      <ListItemText primary="Purses" />
                    </Link>

                    <Link to="/category/jewelry">
                      <ListItemText primary="Jewelry" />
                    </Link>

                    <Link to="/category/shoes">
                      <ListItemText primary="Shoes" />
                    </Link>

                    <Link to="/category/used_bag_packs">
                      <ListItemText primary="Used bag packs" />
                    </Link>
                  </List>
                </Collapse>
                <ListItemButton>
                  <ListItemText primary="Contact Us" />
                </ListItemButton>
              </List>
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {/* <img src="Images/nav.png" style={{ width: "300px" }} alt="logo" /> */}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            <MDBDropdown group className="shadow-0">
              <MDBDropdownToggle color="transparent">
                <span style={{ color: "white" }}>Products</span>
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link href="/category/hand_bags">
                  Hand Bags
                </MDBDropdownItem>
                <MDBDropdownItem link href="/category/jewelry">
                  Jewelry
                </MDBDropdownItem>
                <MDBDropdownItem link href="/category/purse">
                  Purse
                </MDBDropdownItem>
                <MDBDropdownItem link href="/category/shoes">
                  Shoes
                </MDBDropdownItem>
                <MDBDropdownItem link href="/category/used_bag_packs">
                  Used Bag Packs
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
            <MDBBtn color="transparent" link>
              <span style={{ color: "white" }}>Contact Us</span>
            </MDBBtn>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            {Auth.getUser() != null ? (
              <>
                <Tooltip title="Add Item">
                  <IconButton
                    onClick={() => navigate("/additem")}
                    sx={{ p: 0 }}
                  >
                    <Add sx={{ color: "white" }} />
                  </IconButton>
                </Tooltip>{" "}
                <Tooltip title="Log out">
                  <IconButton onClick={() => navigate("/login")} sx={{ p: 0 }}>
                    <Logout sx={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Login">
                <IconButton onClick={() => navigate("/login")} sx={{ p: 0 }}>
                  <LoginIcon sx={{ color: "white" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavigationBar;
